import PolicyDocumentView from "../../components/public/PolicyDocumentView";

export default function CancellationRefundPolicy() {
  return <PolicyDocumentView slug="cancellation-refund-policy" fallbackTitle="Cancellation and Refund Policy" />;
}
